<template>
	<Page animate>
		<template v-slot:content>
			<SafeAreaTop @close="onClose" closePosition="left" theme="dark">
				<div class="container">
					<div class="promo">
						<img :src="require(`@/assets/paywall/gift.png`)" alt="" />
					</div>

					<div class="title">Thanks, here’s your Simple Premium discount</div>
					<div class="subtitle">Special offer just for you! A year with Simple</div>

					<Products
						class="compact"
						:products="products"
						:active="active_product"
						@select="handleSelect"
						theme="orange"
					/>

					<div class="title-timeline">How your Special Offer works</div>

					<div class="timeline">
						<div class="timeline-item">
							<div class="timeline-title">
								<div class="timeline-title--icon">
									<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M7.31034 12.7207L11.0896 16.4999L16.8337 10.7559C17.2242 10.3653 17.2242 9.73217 16.8337 9.34164C16.4432 8.95112 15.81 8.95111 15.4195 9.34164L11.0896 13.6715L8.72455 11.3065C8.33403 10.9159 7.70086 10.9159 7.31034 11.3065C6.91982 11.697 6.91982 12.3302 7.31034 12.7207Z"
											fill="#424982"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
											fill="#424982"
										/>
									</svg>
								</div>
								<div class="timeline-title--text">Today</div>
							</div>
							<div class="timeline-body">
								The first 12 weeks will cost you {{ active_product.introductory?.localized_price }}
							</div>
						</div>
						<div class="timeline-item">
							<div class="timeline-title">
								<div class="timeline-title--icon">
									<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M13.972 16.6687H10.028C10.1068 17.1347 10.3481 17.5577 10.7091 17.8627C11.0701 18.1678 11.5274 18.3352 12 18.3352C12.4726 18.3352 12.93 18.1678 13.291 17.8627C13.6519 17.5577 13.8932 17.1347 13.972 16.6687Z"
											fill="#424982"
										/>
										<path
											d="M15.5356 6.79979C14.5979 5.86211 13.3261 5.33533 12 5.33533C10.7045 5.33539 9.4595 5.839 8.52743 6.73885C7.59536 7.63871 7.04897 8.86523 7.00336 10.16L7.00003 10.3267V13.0013L6.0567 15.108C6.01355 15.2044 5.99521 15.3101 6.00335 15.4155C6.01149 15.5208 6.04584 15.6224 6.10329 15.7111C6.16074 15.7997 6.23946 15.8726 6.33227 15.9231C6.42509 15.9735 6.52905 16 6.6347 16H17.368C17.4735 15.9998 17.5773 15.9733 17.67 15.9228C17.7626 15.8723 17.8412 15.7995 17.8985 15.711C17.9559 15.6224 17.9902 15.5209 17.9984 15.4158C18.0066 15.3106 17.9883 15.205 17.9454 15.1087L17 13.002V10.3353C17 9.00924 16.4732 7.73747 15.5356 6.79979Z"
											fill="#424982"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
											fill="#424982"
										/>
									</svg>
								</div>
								<div class="timeline-title--text">{{ next_billing_date }}</div>
							</div>
							<div class="timeline-body">
								{{ active_product?.localized_price }} will be charged from your account on this day
							</div>
						</div>
						<div class="timeline-item">
							<div class="timeline-title">
								<div class="timeline-title--icon">
									<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M13.14 14.4199H10.9252L10.7142 6H13.351L13.14 14.4199Z" fill="#F7AB61" />
										<path
											d="M13.4652 17.4082C13.4652 18.1816 12.8324 18.7881 12.0326 18.7881C11.2328 18.7881 10.6 18.1816 10.6 17.4082C10.6 16.6348 11.2328 16.0283 12.0326 16.0283C12.8324 16.0283 13.4652 16.6348 13.4652 17.4082Z"
											fill="#F7AB61"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
											fill="#F7AB61"
										/>
									</svg>
								</div>
								<div class="timeline-title--text">Please Note</div>
							</div>
							<div class="timeline-body">
								Don’t change your subscription until {{ next_billing_date }} to successfully activate your Special Offer
							</div>
						</div>
					</div>
				</div>
			</SafeAreaTop>

			<Prompt
				:isOpen="showPaywallCancelPrompt"
				title="Purchase Failed"
				:text="`Cannot connect to the ${
					platform == 'ios' ? 'iTunes Store' : 'Play Store'
				}. Please check your internet connection and try again`"
				action="Retry"
				@onClose="onClosePaywallCancelPrompt"
				@onAction="onActionPaywallCancelPrompt"
			/>
		</template>

		<template v-slot:footer>
			<div class="container">
				<p-button @click.prevent="handleSubmit" label="" :loading="isLoading" cls="btn-primary btn-block">
					Get the Offer
				</p-button>
			</div>
		</template>
	</Page>
</template>

<script>
import Page from '@/components/Page'
import Prompt from '@/components/Prompt'
import PButton from '@/components/Button'
import Products from '@/components/products/ios/Products'
import { computed, ref } from '@vue/reactivity'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import useApi from '@/composition/api.js'
import useConfig from '@/composition/config.js'
import SafeAreaTop from '@/components/SafeAreaTop.vue'
import { inject, watch } from '@vue/runtime-core'

import addMonths from 'date-fns/addMonths'
import format from 'date-fns/format'

export default {
	components: {
		Page,

		Products,
		SafeAreaTop,
		PButton,
		Prompt
	},

	setup() {
		try {
			const amplitude = inject('amplitude')
			const store = useStore()
			const api = useApi()
			const config = useConfig()
			const router = useRouter()
			const platform = api.getPlatform()

			const products = computed(() => {
				return store.getters['products/getData']([
					{
						id: 'simple_3_months_4999_9_for_introductory',
						text: '12 Weeks - [introductory_price]/First 4-week',
						subtitle: 'Then [price]/12-week'
					}
				])
			})

			const next_billing_date = computed(() => format(addMonths(new Date(), 3), 'PP'))

			let active_product = ref(products.value[0])
			watch(products, () => {
				active_product.value = products.value[0]
			})

			const postPaid = computed(() => config.get({ key: 'postPaid', default_value: true }))
			const next = computed(() => config.get({ key: 'postPaid.type', default_value: 'workbooks-bundle' }))

			const close = (Status = 'Close', NextRoute = null) => {
				amplitude.logEvent('Paywall - Close', {
					Layout: config.get({ key: 'layout', default_value: 'After Cancel' }),
					From: store.getters['getSource'],
					Step: 'Paywall',
					Status
				})
				if (postPaid.value == 'false') {
					api.close()
				} else {
					router.push({
						name: NextRoute || next.value
					})
				}
			}

			let isLoading = computed(() => store.state.isLoading)

			let showPaywallCancelPrompt = ref(false)

			const onClose = () => close()

			const Purchase = (product) => {
				api.purchase({
					productId: product.id,
					onFinish: () => {
						amplitude.logEvent('Paywall - Done', {
							Layout: config.get({ key: 'layout', default_value: 'After Cancel' }),
							From: store.getters['getSource'],
							Step: 'Paywall',
							ProductId: product.id,
							Status: 'Subscribe'
						})
						close('Subscribe')
					},
					onError: () => {
						console.log('error')
					},
					onCancel: () => {
						showPaywallCancelPrompt.value = true
					},
					closeOnSuccess: false
				})
			}

			const handleSelect = (product) => {
				active_product.value = product
			}

			const onClosePaywallCancelPrompt = () => {
				showPaywallCancelPrompt.value = false
			}

			const onActionPaywallCancelPrompt = () => {
				showPaywallCancelPrompt.value = false
				Purchase(active_product.value)
			}

			const handleSubmit = () => {
				Purchase(active_product.value)
			}

			return {
				products,
				active_product,
				isLoading,
				handleSelect,
				handleSubmit,
				showPaywallCancelPrompt,
				onClosePaywallCancelPrompt,
				onActionPaywallCancelPrompt,
				onClose,
				platform,
				next_billing_date
			}
		} catch (e) {
			document.getElementById('log').innerHTML = e
		}
	}
}
</script>

<style scoped lang="scss">
.title {
	font-weight: bold;
	font-size: 1.8rem;
	text-align: left;
	padding-top: 0rem;
	line-height: 1.3;
	color: #424982;
	max-width: 90%;
}

.subtitle {
	color: #6a6d82;
	font-size: 1.2rem;
	margin-top: 0.5rem;
	line-height: 1.34;
	max-width: 90%;
}

.color-purple {
	color: #e46a8a;
}

.promo {
	padding-top: 5vh;

	img {
		max-width: 90%;
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
}

.links {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 1.4rem;
	flex-wrap: wrap;

	span {
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background-color: #3b3c57;
		margin: 2px 12px;
		opacity: 0.5;
	}

	a {
		text-decoration: none;
		color: #3b3c57;
		font-size: 0.9rem;
		display: block;
		margin: 2px 0;
	}
}

.absolute {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
	width: 100%;
}

.title-timeline {
	margin-top: 2.2rem;
	font-weight: bold;
	font-size: 1.8rem;
	text-align: left;
	padding-top: 0rem;
	line-height: 1.3;
	color: #424982;
}

.timeline {
	margin-top: 1.4rem;

	&-item {
		margin-bottom: 1.3rem;
	}
	&-title {
		position: relative;
		padding-left: 2.66rem;

		&--icon {
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-53%);

			svg {
				width: 1.66rem;
				display: block;
			}
		}

		&--text {
			font-weight: bold;
			font-size: 1.3rem;
			color: #424982;
		}
	}

	&-body {
		padding-left: 2.66rem;
		margin-top: 0.2rem;
		font-size: 1.1rem;
		color: #6a6d82;
		line-height: 1.4;
	}
}
</style>
